<template>
  <div>
    <mt-header fixed title="">
      <div slot="left">
        <span @click="goBack" class="backSpan"><img src="../assets/imgs/backIcon.png" alt=""></span>
        <mt-button router-link="'/'">服务单位转移</mt-button>
      </div>
      <mt-button  slot="right">保存</mt-button>
    </mt-header>
    <mt-cell title="原单位" value="-"></mt-cell>
    <mt-cell title="新单位" value="-"></mt-cell>
    <mt-cell title="当月所属" value="新单位"></mt-cell>
    <mt-cell title="从业资格编号" value="-"></mt-cell>
    <div class="showInfo">
      <ul>
        <li>1.学习进度达到大纲学时，转移到新单位时，当月将不用学习，学习时不计学时。</li>
        <li>2.学习进度未达到大纲学时，转移到新单位时，你单位需要重新学习，学习记学时。</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userinfos',
  methods: {
    goBack: function () {
      history.back()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ServerComChange.vue